// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "iransans";
  src: url("/assets/fonts/iranyekan.ttf");
}
@font-face {
  font-family: "iransansbold";
  src: url("/assets/fonts/iranyekanbold.ttf");
}
#loading {
  justify-content: center;
  text-align: center;
  margin: auto;
}

::ng-deep .mat-mdc-progress-spinner circle {
  stroke: #002B5B;
}`, "",{"version":3,"sources":["webpack://./src/app/app.component.scss"],"names":[],"mappings":"AAAA;EACE,uBAAA;EACA,uCAAA;AACF;AAEA;EACE,2BAAA;EACA,2CAAA;AAAF;AAGA;EAGE,uBAAA;EACA,kBAAA;EACA,YAAA;AAHF;;AAWA;EACE,eAAA;AARF","sourcesContent":["@font-face{\r\n  font-family: \"iransans\";\r\n  src: url('/assets/fonts/iranyekan.ttf');\r\n}\r\n\r\n@font-face{\r\n  font-family: \"iransansbold\";\r\n  src: url('/assets/fonts/iranyekanbold.ttf');\r\n}\r\n\r\n#loading {\r\n  // width: 30px;\r\n  // height: 30px;\r\n  justify-content: center;\r\n  text-align: center;\r\n  margin: auto;\r\n  // margin-top: 50px;\r\n}\r\n\r\n// ::ng-deep .mat-progress-spinner circle, .mat-spinner circle {\r\n//   stroke: #fdb800 !important;\r\n// }\r\n\r\n::ng-deep .mat-mdc-progress-spinner circle {\r\n  stroke: #002B5B;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
